import React, { useState } from 'react';
import axios from 'axios';
import CreateConnectionButton from '../../components/FormPage/CreateConnectionButton';
import {ToastContainer, toast, Slide} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

export default function ConnectionCreation(args) {
    //ODBC Connection Creation
    //Connection name - input type=text, Username - input type=text, password - input type=text, server - input type=text, port - input type=text, type - select (terradata, mysql, neo4j, mongo), database - input type=text
    //Create/submit button

    const [isHidden, setIsHidden] = useState(true);
    const [connectionName, setConnectionName] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [server, setServer] = useState('');
    const [port, setPort] = useState('');
    const [database, setDatabase] = useState('');
    const [type, setType] = useState('');

    const handleToggle = () => {
        setIsHidden(!isHidden);
    }

    function handleSubmit(e){
        //add form validation
        axios.post('/api/connectiondetails', {
            connectionName,
            userName,
            password,
            server,
            port,
            database,
            type
        }).then(r => {
	    console.log(r.data);
	    toast('Connection Created');
        }).catch(e => {
            console.error(e)
        })
    }

    return (
        <div className="p-6 w-4/5" style={{marginLeft: "8rem"}}>
  	    <ToastContainer
  		position="top-center"
  		transition={Slide}
  		hideProgressBar={true}
  		bodyClassName="text-gray-600"
  		progressClassName="bg-purple-500"
  	    />
            <h1 className="text-3xl py-4 px-3 ml-5 border-b mb-10">ODBC Connection Creation</h1>
            <div className="ml-5 p-5 mb-4 bg-white shadow">
                <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">Add Connection Details</h2>
                <div className="flex justify-between mt-5 mb-2 px-6 pb-1 border-b border-dashed border-gray-200">
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="connection-name">
                            Connection Name
                        </label>
                        <input value={connectionName} onChange={(e) => {setConnectionName(e.target.value)}} type="text" id="connection-name" name="connection-name" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="username">
                            Username
                        </label>
                        <input value={userName} onChange={(e) => {setUserName(e.target.value)}} type="text" id="username" name="username" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Username..."/>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="password">
                            Password
                        </label>
                        <div className="relative flex items-center">
                            <input value={password} onChange={(e) => {setPassword(e.target.value)}} type={isHidden ? 'password' : 'text'} id="password" name="password" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline" placeholder="Enter Password..."/>
                            <i onClick={handleToggle} className={isHidden ? "far fa-eye-slash absolute right-0 mr-3" : "far fa-eye"}></i>
                        </div>
                    </div>
                </div>
                <div className="flex justify-between mt-5 mb-2 px-6 pb-1 border-b border-dashed border-gray-200">
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="server">
                            Server
                        </label>
                        <input value={server} onChange={(e) => {setServer(e.target.value)}} type="text" id="server" name="server" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="port">
                            Port
                        </label>
                        <input value={port} onChange={(e) => {setPort(e.target.value)}} type="text" id="port" name="port" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                    </div>
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect" for="database">
                            Database
                        </label>
                        <input value={database} onChange={(e) => {setDatabase(e.target.value)}} type="text" id="database" name="database" className="appearance-none border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline"/>
                    </div>
                </div>
                <div className="flex justify-between mt-5 mb-2 px-6 pb-1 border-b border-dashed border-gray-200">
                    <div className="flex flex-col justify-center">
                        <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                                Type
                        </label>
                        <select value={type} onChange={(e) => {setType(e.target.value)}} className="border rounded w-full py-2 px-3 text-lg text-gray-800 leading-tight focus:outline-none focus:shadow-outline">
                            <option>Teradata</option>
                            <option>MySQL</option>
                            <option>Neo4j</option>
                            <option>MongoDB</option>
                        </select>
                    </div>
                </div>
            </div>
            <CreateConnectionButton handleSubmit={handleSubmit} />
        </div>
    );
}
